<template>
  <div class="login-user-password-modifier">
    <el-form
      :model="passwordForm"
      :rules="passwordFormRules"
      ref="passwordForm"
      size="mini"
      label-width="120px"
    >
      <el-form-item label="旧密码：" prop="password">
        <el-input type="password" style="width:320px;" maxlength="16" minlength="8" placeholder="请输入旧密码" show-password v-model="passwordForm.password"/>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input type="password" style="width:320px;" maxlength="16" minlength="8" placeholder="请输入新密码" show-password v-model="passwordForm.newPassword"/>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPassword">
        <el-input type="password" style="width:320px;" maxlength="16" minlength="8" placeholder="请输入确认密码" show-password v-model="passwordForm.confirmPassword"/>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col class="col-text-align">
        <el-button size="mini" style="width: 110px" class="common-button"
                   @click.native.prevent="handleClick()">确 定
        </el-button>
        <el-button size="mini" style="width: 110px" class="clear-button"
                   @click.native.prevent="handleClose()">取 消
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'LoginUserPasswordModifier',
  data() {
    const regex = {
      lowerCase: /[a-z]/,
      upperCase: /[A-Z]/,
      number: /[0-9]/,
      specialChar: /[!@#$%^&*(),.?":{}|<>]/
    }
    let validatePassword = (rule, value, callback) => {
      if (_.isEmpty(value)) {
        callback(new Error("请输入旧密码。"))
      } else if (value !== this.loginUserFromStorage.password) {
        callback(new Error("旧密码不正确。"))
      } else {
        callback()
      }
    }
    let validateNewPassword = (rule, value, callback) => {
      if (_.isEmpty(value)) {
        callback(new Error("请输入新密码。"))
      } else if (value.toString().length < 8 || value.toString().length > 16) {
        callback(new Error("请输入8-16位的新密码。"))
      } else {
        let typeCnt = 0;
        if (regex.lowerCase.test(value)) typeCnt++;
        if (regex.upperCase.test(value)) typeCnt++;
        if (regex.number.test(value)) typeCnt++;
        if (regex.specialChar.test(value)) typeCnt++;
        
        if (typeCnt < 3) {
          callback(new Error("新密码必须同时包含大写、小写、数字和特殊字符其中三项。"))
        }
        if (value === this.passwordForm.password) {
          callback(new Error("新密码不能和旧密码一致。"))
        }
        callback()
      }
    }
    let validateConfirmPassword = (rule, value, callback) => {
      if (_.isEmpty(value)) {
        callback(new Error("请输入确认密码。"))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error("确认密码输入不正确。"))
      } else {
        callback()
      }
    }
    return {
      validateStatus: false,
      passwordForm: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordFormRules: {
        password: [
          {required: true, validator: validatePassword, trigger: 'blur'}
        ],
        newPassword: [
          {required: true, validator: validateNewPassword, trigger: 'blur'}
        ],
        confirmPassword: [
          {required: true, validator: validateConfirmPassword, trigger: "blur"}
        ]
      }
    }
  },
  computed: {
    ...mapState({loginUserFromStorage: 'rememberUser'})
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogVisible', false)
    },
    async handleClick() {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          let param = new URLSearchParams();
          param.append("usrCd", this.loginUserFromStorage.userId);
          param.append("usrPwd", this.passwordForm.confirmPassword);
          let result = (await this.axios.post('/usr/updatePwd', param)).data.retResult
          if (result.state == 'success') {
            this.$message.success("密码修改成功，请重新登录。")
            setTimeout(() => {
              this.logout()
            }, 1000)
          } else if (result.state == "error") {
            this.$message({ message: '密码修改失败。',
              type: "error",
              duration: "2000"
            })
            return false
          }
        }
      })
    },
    async logout() {
      await this.$store.dispatch('logout')
      await this.$router.push('/login')
    }
  }
}
</script>

<style>
.login-user-password-modifier .clear-button {
  background-color: white;
  color: #64B0B2;
  border-color: #64B0B2;
}

.login-user-password-modifier .clear-button:hover, .search-condition-button-tray .clear-button:focus {
  opacity: 0.8;
  background-color: #64B0B2;
  border-color: #64B0B2;
  color: white;
}
</style>
